import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-support-dialog',
    template: `
    <div id="contactSupportModal">
      <app-popup-header [headerTitle]="title"></app-popup-header>
      <mat-dialog-content class="mySedwick-popupContent">
        <br aria-hidden="true" />
        <div
          class="margin-5"
          class="tw-flex tw-flex-wrap tw-flex-col"
          id="moreoptionparent"
        >
          <label id="expandSection" class="expand-collapse">
            <br aria-hidden="true" /><br aria-hidden="true" />
            <ng-container *ngTemplateOutlet="techSupport"></ng-container>
          </label>
        </div>
        <br aria-hidden="true" /><br aria-hidden="true" />
      </mat-dialog-content>

      <mat-dialog-actions align="end" class="mySedwick-popupFooter">
        <app-button
          emphasis="High"
          mat-button
          [mat-dialog-close]="true"
          aria-label="OK"
          mat-raised-button
          (click)="doClose()"
          label="OK"
        >
        </app-button>
      </mat-dialog-actions>
    </div>

    <ng-template #techSupport>
      <span class="right10">
        {{'Sedgwick Technical Support is available from 7:00 a.m. to 6:00 p.m., Central Time, Monday through Friday.' | translation: translationRequest}}
      </span>
      <br aria-hidden="true" /><br aria-hidden="true" />
      <span aria-label="Toll free Number 8666477610 .">
        {{'Toll-free Number : (866) 647-7610' | translation: translationRequest}}
      </span>
      <br aria-hidden="true" />
      <span aria-label="Toll Number 9014157800">
        {{'Toll Number : (901) 415-7800' | translation: translationRequest}}
      </span>
    </ng-template>
  `,
    styles: [
        `
      .support-dialog {
        max-width: 500px;
      }

      .expand-collapse {
        //height: auto;
        width: inherit;
        padding-top: 20px;
        padding-left: 15px;
        padding-right: 20px;
        padding-bottom: 10px;
      }
      .expand-collapse-hidden {
        display: none;
        height: 0px;
        max-height: 0px;
        width: inherit;
        padding-top: 20px;
        padding-left: 15px;
        padding-right: 20px;
        padding-bottom: 40px;
      }

      .login-icon {
        margin-right: 5px;
      }

      .expandCollapseHover {
        cursor: pointer;
      }
      .mat-mdc-button:focus {
        border: 2px solid white !important;
        outline: 3px solid black !important;
      }
      #spnmoresupportoption:focus {
        border: 2px solid white !important;
        outline: 3px solid black !important;
      }
    `,
    ],
    standalone: false
})
export class SupportDialogComponent implements OnInit, OnDestroy {
  @ViewChild('displayLocation') myDiv: ElementRef;

  isVisible: boolean;
  title: string = 'Technical Support';

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
  
  constructor(private dialogRef: MatDialog) {}

  ngOnInit(): void {
    this.isVisible = true;
  }

  ngOnDestroy(): void {
    this.doClose();
  }

  doClose(): void {
    this.isVisible = false;
    this.dialogRef.closeAll();
  }
}
